module.exports = __webpack_public_path__ + "static/img/bg_02.d804a4d4.jpg";